// Wortlaute der Erklärung „Mitarbeiter“. Regeln für jeden Text: siehe ../help.js.
export default {
  title: "Mitarbeiter",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    EmployeeOverview: "Übersicht",
    EmployeeDetail: "Mitarbeiter",
    SettingsOverview: "Einstellungen",
    UserPositionOverview: "Personalrollen",
    TimeTrackingReview: "Zeiterfassung",
  },
  // Die Seiten außerhalb der Mitarbeiterverwaltung, die sie einrichten und die den Datensatz einer
  // Person wieder lesen. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier stehen alle Mitarbeiter mit Personalrolle und Telefon. Das Symbol vor der E-Mail sagt, ob die Person sich anmelden kann.",
    },
    create: {
      text: "Mit dieser Schaltfläche legen Sie neue Mitarbeiter an. Zuerst wählen Sie, ob die Person ein Login-Benutzer wird.",
    },
    row: { text: "Ein Klick auf eine Zeile öffnet die Person mit allen ihren Daten." },
    head: { text: "Oben stehen Name und Profilbild der Person." },
    type: {
      text: "Dieser Hinweis sagt, ob die Person ein Login-Benutzer ist und sich anmelden kann. Verwaltungsbenutzer melden sich nie an.",
    },
    actions: {
      text: "Unter Aktionen löschen Sie die Person, setzen ihr Passwort zurück oder machen aus ihr einen Login-Benutzer.",
    },
    "action-times": {
      text: "Zeiten prüfen öffnet die Prüfung der Zeiterfassung mit dieser Person. Dort geben Sie ihre Tage frei.",
    },
    "action-planning": {
      text: "In Personalplanung anzeigen öffnet den Kalender, in dem die Person eingeplant ist. Bei mehreren Kalendern wählen Sie einen aus.",
    },
    tabs: {
      text: "Alles zu dieser Person liegt in Reitern. Unter Allgemein stehen Name, Geburtsdatum, Telefon und Adresse.",
    },
    "company-position": {
      text: "Die Personalrolle bestimmt, mit welchem Stundensatz die Stunden dieser Person in den Projektkosten gerechnet werden.",
    },
    "company-wage": {
      text: "Lohnart und Lohn halten fest, wie diese Person bezahlt wird. Die Projektkosten rechnen mit dem Satz ihrer Personalrolle.",
    },
    "company-worktime": {
      text: "Das Arbeitszeitmodell gehört zur Zeiterfassung. Die Erklärung dort sagt, was es für Soll und Saldo bedeutet.",
    },
    "company-contribution": {
      text: "Der Arbeitgeberanteil ist ein Aufschlag auf die Personalkosten. Leer heißt, der Standard aus den Einstellungen gilt.",
    },
    "company-holidays": {
      text: "Urlaubstage und die Angaben zur Sozialversicherung gehören zur Personalakte.",
    },
    "system-email": {
      text: "Mit dieser Adresse meldet sich ein Login-Benutzer an. An sie gehen auch seine Zugangsdaten.",
    },
    "system-roles": {
      text: "Die zugeordneten Rollen entscheiden, was diese Person sehen und ändern darf. Ein Klick schiebt eine Rolle hin und zurück.",
    },
    files: {
      text: "In der Dateiablage liegen Dokumente zur Person, etwa Vertrag oder Nachweise. Sie können Dateien hier hochladen.",
    },
    extended: {
      text: "Benutzerdefinierte Felder gelten für alle Mitarbeiter. Hier legen Sie eines an und füllen es für diese Person.",
    },
    activity: {
      text: "Das Protokoll zeigt, wer wann was geändert hat. Unter Verweise steht, wo die Person im System verwendet wird.",
    },
    save: { text: "Speichern übernimmt die Änderungen aus allen Reitern auf einmal." },
    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },
    rights: {
      text: "Hier entstehen die Rollen, die Sie einer Person im Reiter System spezifisch zuweisen. Eine Rolle ist eine Liste von Rechten.",
    },
    contribution: {
      text: "Dieser Arbeitgeberanteil gilt für alle Mitarbeiter. Am einzelnen Mitarbeiter überschreiben Sie ihn im Reiter Unternehmens-relevant.",
    },
    positions: {
      text: "Zu jeder Personalrolle gehört ein Stundensatz. Er ist der Kostensatz einer Stunde und der Vorschlag, wenn ein Projekt die Rolle aufnimmt.",
    },
    times: {
      text: "Was eine Person erfasst, läuft in der Zeiterfassung unter Mitarbeiter zusammen. Gemessen wird sie am Arbeitszeitmodell aus ihrem Reiter Unternehmens-relevant.",
    },
  },
}
